import { useState } from 'react';

const useCardMask = (fieldName, setFieldValue) => {
  const [maskedValue, setMaskedValue] = useState(''); // Valor enmascarado
  const [realValue, setRealValue] = useState(''); // Valor real (sin máscara)

  const formatCardNumber = (value) => {
    const masked = value
      .split('')
      .map((char, idx) => (idx < 12 ? '•' : char)) // Oculta todos menos los últimos 4
      .join('');

    return masked.replace(/(.{4})/g, '$1 ').trim();
  };

  const handleCardNumberChange = (inputValue) => {
    // Elimina los espacios del valor ingresado
    const sanitizedInput = inputValue.replace(/\s/g, '');

    if (sanitizedInput.length > realValue.length) {
      // Usuario está agregando caracteres
      const newValue = sanitizedInput.slice(realValue.length); // Extrae los números nuevos
      const updatedRealValue = realValue + newValue; // Concatena los números nuevos

      setRealValue(updatedRealValue);
      setFieldValue(fieldName, updatedRealValue); // Guarda el valor real en Formik
      setMaskedValue(formatCardNumber(updatedRealValue)); // Actualiza el valor enmascarado
    } else if (sanitizedInput.length < realValue.length) {
      // Usuario está borrando caracteres
      const updatedRealValue = realValue.slice(0, sanitizedInput.length);
      setRealValue(updatedRealValue);
      setFieldValue(fieldName, updatedRealValue); // Guarda el valor real en Formik
      setMaskedValue(formatCardNumber(updatedRealValue)); // Actualiza el valor enmascarado
    } else setFieldValue(fieldName, realValue); // Mantener el valor real en Formik
  };

  return {
    maskedValue,
    handleCardNumberChange,
    setMaskedValue,
    setRealValue,
  };
};

export default useCardMask;
